export default {
    adMessage: {
        slotId: 'j_id_1m8',
    },
    playButtonImage: {
        small: 'https://content.autotrader.com/content/dam/autotrader/collections/landing/hero/AT_play_button_sm.png',
        large: 'https://content.autotrader.com/content/dam/autotrader/collections/landing/hero/AT_play_button.png',
    },
};
